const _ = require('lodash')
const coreUtils = require('@wix/santa-core-utils')
const dataUtils = require('../../helpers/dataUtils')

/**
 *
 * @param {object} structure - page structure
 * @param {string} compType - component type to look for
 * @returns {{mobileComps: Array, desktopComps: Array, mobileOnlyComponentsIds: object, components: Record<string,import('./index').ComponentStructure>}} mobileComps, desktopComps, mobileOnlyComponentsIds, allUniqueComps
 * @description returns all components of a given type in the page structure
 */
function getAllComponentsOfType(structure, compType) {
    function getAllCompsInStructure(isMobile) {
        return coreUtils.dataUtils.getAllCompsInStructure(structure, isMobile, comp => comp.componentType === compType)
    }
    const mobileComps = getAllCompsInStructure(true)
    const desktopComps = getAllCompsInStructure(false)
    const mobileCompsIds = _.map(mobileComps, 'id')
    const desktopCompsIds = _.map(desktopComps, 'id')
    const mobileOnlyComponentsIds = _.difference(mobileCompsIds, desktopCompsIds)

    const components = {...mobileComps, ...desktopComps}

    return {mobileComps, desktopComps, mobileOnlyComponentsIds, components}
}

/**
 * Components inside Blocks Widgets do not exist in the page structure, but their style overrides (over the widget's original styles)
 * are written in the page styles. So to gater them we need to look in the style, rather than in the structure
 * @param {object} props
 * @param {object} props.styles
 * @param {Array<import('./index').ComponentStructure>} props.refComponents
 * @param {string} props.compType - component type to look for
 * @returns {Array<import('./index').ComponentStructure>}
 * @description returns all components of a given type from remote structure - Blocks Widgets
 */
function getAllRemoteStructureComponentsOfType({styles, compType, refComponents}) {
    function getAllWidgetsStyleOverrides(compId) {
        return Object.entries(styles).reduce((acc, [key, value]) => {
            if (_.startsWith(key, `${compId}_r_`)) {
                return [...acc, value]
            }
            return acc
        }, [])
    }

    function getCompInfoFromStyle(style) {
        const {compId: id, skin, id: styleId} = style
        return {
            id,
            skin,
            styleId,
            compType
        }
    }

    function getRemoteStructureCompsInfo(allStyleOverrides) {
        return allStyleOverrides.reduce((acc, styleOverride) => {
            const isRefArray = dataUtils.refArray.isRefArray(styleOverride)
            const stCss = _.get(styleOverride, 'style.properties.$st-css') ?? ''
            const isComponentToMigrate = styleOverride.componentClassName === compType || stCss.includes(compType)
            if (!isRefArray && isComponentToMigrate) {
                const component = getCompInfoFromStyle(styleOverride)
                return [
                    ...acc,
                    {
                        ...component,
                        isFromRemoteStructure: true
                    }
                ]
            } else if (dataUtils.refArray.isRefArray(styleOverride)) {
                const mainStyleItemId = styleOverride.values[0].replace('#', '')
                const mainStyleItem = styles[mainStyleItemId]
                if (mainStyleItem.componentClassName === compType) {
                    const component = getCompInfoFromStyle(mainStyleItem)
                    return [
                        ...acc,
                        {
                            ...component,
                            styleId: styleOverride.id,
                            isFromRemoteStructure: true
                        }
                    ]
                }
            }
            return acc
        }, [])
    }

    return refComponents.reduce((acc, refComponent) => {
        const allStyleOverrides = getAllWidgetsStyleOverrides(refComponent.id)
        const compsStyleOverrideToMigrate = getRemoteStructureCompsInfo(allStyleOverrides)
        return [...acc, ...compsStyleOverrideToMigrate]
    }, [])
}

module.exports = {getAllComponentsOfType, getAllRemoteStructureComponentsOfType}
